import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/1opssLogo2.png";


export default function Navbar() {
  return (
    <header className="header container" role="banner" style={{backgroundColor:"white", paddingBottom:"5px"}}>
      <div style={{display:"flex", flexDirection:"row", alignContent:"center"}}>
          <Link to="/" className="brand">
        
          <span className="logo" aria-hidden="true">
            <img src={logo} alt="Home" style={{height:"150px", width:"200px"}}></img>
            {/* <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="14" height="16" rx="2" stroke="#2f6be6" strokeWidth="1.6" /></svg> */}
          </span>
          <div>
            <div style={{fontWeight:700}}>Professional Services</div>
            <div style={{fontSize:12, color:'var(--muted)'}}>Vetted pros • Secure</div>
          </div>
        </Link>
        <span style={{flexGrow:1}}></span>
        <Link style={{
          paddingRight:"5%",
          alignSelf:"center", 
          justifySelf:"flex-end",
          textDecoration:"none"
        }} to="/signup" className="cta">Sign Up/Login</Link>
      </div>


      <nav className="nav-links" role="navigation">
        <Link to="/how-it-works">How it works</Link>
        <Link to="/directory">Service Offerings</Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/partner-with-us">Partner with Us</Link>
        <Link to="/about" className="cta">About Us</Link>
      </nav>
      
    </header>
  )
}
